import { Deserializable } from '../protocols/deserializable';
import { SubmissionSubStatusIdEnum } from '../enum/shared/submission-sub-status-id-enum';
import { SubmissionStatusEnum } from '../enum/shared/submission-status.enum';
import { BaseType } from '../base/base-type';

export class SubmissionSubStatus extends BaseType implements Deserializable {
  public declare id: SubmissionSubStatusIdEnum;
  public parentStatus!: string;
  public parentStatusId!: SubmissionStatusEnum;

  onDeserialize() {}
}
